/* Turning Hearts site pages (not the home page). */
// Live numbers (photos shared, life events shared) from the memorial wall, exact, refreshed on every visit.
(function () {
  var box = document.querySelector('[data-ths-stats]'); if (!box || !window.fetch) return;
  fetch(box.getAttribute('data-ths-stats') + '?page=1', { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
    var st = d && d.stats; if (!st) return;
    box.querySelectorAll('[data-ths-stat]').forEach(function (el) { var v = st[el.getAttribute('data-ths-stat')]; if (typeof v === 'number' && v > 0) el.textContent = v.toLocaleString('en-US'); });
  }).catch(function () {});
})();